import React from 'react';
import './Login.css'
import AuthenticationService from '../../Services/AuthenticationService'
import LoginDialog from './LoginDialog'

interface State {
  loggedIn: boolean;
  displayName: string;
  isLoginFormOpened: boolean;
  isUserDetailsOpened: boolean;
  userName: string;
  password: string;
  error: string;
  avatar: string;
  webUrl: string;
  inProgress: boolean;
}
export default class Login extends React.Component<{}, State> {
  constructor(props: any) {
    super(props);
    this.toggleLoginDialog = this.toggleLoginDialog.bind(this);
    this.state = {
      loggedIn: false,
      displayName: "",
      isLoginFormOpened: false,
      userName: "",
      password: "",
      error: "",
      avatar: "",
      isUserDetailsOpened: false,
      webUrl: "",
      inProgress: false
    }
  }

  public componentDidMount() {
    const session = AuthenticationService.getSessionInfo();
    if (session && !this.state.loggedIn) {
      this.setState({ loggedIn: true, displayName: session.userId });
      const authService = new AuthenticationService();
      authService.getUser().then(u => {
        this.setState({ displayName: u.displayname, avatar: u.ImageUrl });
      });
    }
    AuthenticationService.getUnAuthorizedServerDefinition().then(url => {
      const forgotLink = url.appLocation + "/Pages/Service/ForgotPassword.aspx";
      this.setState({ webUrl: forgotLink });
    })
  }

  onLoginClicked() {
    this.setState({ inProgress: true });
    const authService = new AuthenticationService();
    const { userName: u, password: p } = this.state;
    authService.Login(u, p).then(cu => {
      this.setState({ loggedIn: true });

    }).catch(e => {
      this.setState({ error: e.message, inProgress: false })
    }).finally(() => { this.setState({ inProgress: false }); });
  }

  onLogOutClicked() {
    AuthenticationService.cleanSessionInfo();
    this.setState({ displayName: "", password: "", loggedIn: false, avatar: "" });
  }

  onUserDerailsClicked() {
    const open = !this.state.isUserDetailsOpened;
    this.setState({ isUserDetailsOpened: open });
  }

  toggleLoginDialog() {
    const { isLoginFormOpened: isModalOpen } = this.state;
    this.setState({ isLoginFormOpened: !isModalOpen });
  }

  renderError() {
    if (this.state.error !== "") {
      return (<span className="errorMessage">{this.state.error}</span>);
    }
    return null;
  }

  private renderUserButton() {
    if (this.state.isUserDetailsOpened) {
      return null;
    }
    return (
      <div className="hd-user-outer">
        <div className="hd-user-inner">
          <img src={this.state.avatar} onClick={() => this.onUserDerailsClicked()} />
        </div>
      </div>
    )
  }

  public render() {
    const st = this.state as State;
    if (st.loggedIn) {
      return (
        <div className="login">
          {this.renderUserButton()}
          <LoginDialog isOpen={this.state.isUserDetailsOpened} onClose={() => this.onUserDerailsClicked()}>
            <div style={{ width: '150px' }}>
              <ul className="userMenu">
                <li className="userMenu" onClick={() => this.onUserDerailsClicked()}>
                  <div className="userMenuItem">
                    <div className="hd-user-outer">
                      <div className="hd-user-inner">
                        <img src={st.avatar} />
                      </div>
                    </div>{st.displayName}
                  </div>
                </li>
                <li className="separator" />
                <li className="userMenu">
                  <div onClick={() => this.onLogOutClicked()}>Log Out</div>
                </li>
              </ul>
            </div>
          </LoginDialog>
        </div>)
    }
    return (<span className="login">
      <div onClick={this.toggleLoginDialog}>Login</div>
      <LoginDialog isOpen={this.state.isLoginFormOpened} onClose={() => this.toggleLoginDialog()}>
        <div>
          <h2>Use Your Clarizen ID</h2>
          <input className="texta" id="txtLogin" readOnly={false} placeholder="User Name" value={this.state.userName} onChange={(e) => this.setState({ userName: e.target.value })} />
          <input className="texta" id="txtPassword" readOnly={false} type="password" placeholder="Password" value={this.state.password} onChange={(e) => this.setState({ password: e.target.value })} />
          {this.renderError()}
          <input type="submit" disabled={st.inProgress} className="btn" onClick={() => this.onLoginClicked()} value="Log In" />
          <a id="ForgotUrls" href={st.webUrl}>Forgot password?</a>
        </div>
      </LoginDialog>
    </span >)
  }
}